import { useState } from "react";
import { faRandom } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertMessage, { AlertLevel } from "../../components/AlertMessage";
import Select from "../../components/input/Select";
import ButtonWithForm from "../../components/ButtonWithForm";
import { SimpleOption } from "../../components/input/SimpleListbox";
import { useRandomizeGroupsMutation } from "./peerReviewGroupsApiSlice";

interface RandomizePeerReviewGroupsButtonProps {
	courseHasGroups: boolean;
	disabled: boolean;
	onClick: () => void;
}

export function RandomizePeerReviewGroupsButton(props: RandomizePeerReviewGroupsButtonProps) {
	const [groupSize, setGroupSize] = useState(3);
	const [randomizeGroups] = useRandomizeGroupsMutation();

	function handleRandomizeGroups() {
		randomizeGroups({ minSize: groupSize }).catch((error: any) => {
			console.log(error);
		});
	}

	return (
		<ButtonWithForm
			id="randomize-groups-button"
			className="btn btn-neutral"
			disabled={props.disabled}
			title="Create Random Groups"
			confirmLabel="Create Groups"
			onClick={props.onClick}
			onConfirm={handleRandomizeGroups}
			form={
				<RandomizePeerReviewGroupsForm
					courseHasGroups={props.courseHasGroups}
					groupSize={groupSize}
					updateGroupSize={setGroupSize}
				/>
			}>
			<span className="flex items-center">
				<FontAwesomeIcon className="mr-2" icon={faRandom} /> Randomize
			</span>
		</ButtonWithForm>
	);
}

interface RandomizePeerReviewGroupsFormProps {
	courseHasGroups: boolean;
	groupSize: number;
	updateGroupSize: (groupSize: number) => void;
}

const groupSizeOptions: SimpleOption[] = [
	{ value: 2, label: "2" },
	{ value: 3, label: "3" },
	{ value: 4, label: "4" },
	{ value: 5, label: "5" },
];

function RandomizePeerReviewGroupsForm(props: RandomizePeerReviewGroupsFormProps) {
	return (
		<div>
			{props.courseHasGroups && (
				<AlertMessage
					className="text-sm mt-4 py-2 !px-4"
					type={AlertLevel.Warning}
					message={`Warning: This action will remove all existing groups.`}
					showIcon={true}
				/>
			)}
			<div className="mt-4">
				<Select
					value={props.groupSize}
					setValue={(v) => props.updateGroupSize(Number(v))}
					label="Minimum group size"
					simpleListBoxId="gradeFilter"
					options={groupSizeOptions}
					labelClasses="font-semibold"
					simpleListBoxClasses="w-full"
				/>
			</div>
		</div>
	);
}
